export default {
    methods: {
        getHeadersTabellaPromozioni() {
            return [
                { text: "Cliente", value: "RagSoc", sortable: true },
                {
                    text: "Laminato",
                    value: "Laminato",
                    class: "pl-2 pr-2",
                    sortable: false,
                },
                {
                    text: "Laccato",
                    value: "Laccato",
                    class: "pl-2 pr-2",
                    sortable: false,
                },
                {
                    text: "Porte vendute in promo",
                    value: "Quantita",
                    class: "pl-0 pr-0",
                    sortable: true,
                },
                {
                    text: "Fatturato",
                    value: "Fatturato",
                    class: "pl-4 pr-4",
                    sortable: true,
                },
                {
                    text: "Fatturato in promo",
                    value: "FatturatoPromo",
                    class: "pl-0 pr-0",
                    sortable: true,
                },
                {
                    text: "Differenza fatturato",
                    value: "FatturatoDiff",
                    class: "pl-0 pr-0",
                    sortable: true,
                },
                { text: "PDF", value: "", class: "pl-2 pr-2", sortable: false },
            ]
        }
    }
}